import { useConfirmation } from '@wyz/ui';
import { Trans, useI18n } from '~/common/context';
import { ROLES } from '~/common/helpers';
import { useAccessControl } from '~/common/hooks';
import { ITranslatedVehicleTypeGroup } from '~/common/types';
import { AlphabeticalListItem } from '~/connect/components';

interface Props {
  isActivated: boolean;
  onToggle: () => void;
  coreVehicleTypeGroup: ITranslatedVehicleTypeGroup;
}

export const VehicleTypeListItem = ({
  coreVehicleTypeGroup,
  isActivated,
  onToggle,
}: Props) => {
  const { t } = useI18n();
  const ask = useConfirmation();
  const acl = useAccessControl();

  const toggle = () => {
    const isActivating = !isActivated;
    ask({
      title: t('app.vehicle_type_group.modals.update_status.title'),
      description: t(
        isActivating
          ? 'app.vehicle_type_group.modals.update_status.activate'
          : 'app.vehicle_type_group.modals.update_status.inactivate',
      ),
      cancelBtnText: t('app.common.button.cancel'),
      confirmBtnText: t(
        isActivating
          ? 'app.common.button.activate'
          : 'app.common.button.deactivate',
      ),
      confirmBtnVariant: isActivating ? 'success' : 'danger',
    }).onConfirm(() => {
      onToggle();
    });
  };

  return (
    <AlphabeticalListItem
      isAdded={isActivated}
      item={coreVehicleTypeGroup}
      label={
        <Trans i18nKey={coreVehicleTypeGroup.i18nKey}>
          {coreVehicleTypeGroup.name}
        </Trans>
      }
      value={coreVehicleTypeGroup.name}
      onAdd={() => toggle()}
      onRemove={() => toggle()}
      canAdd={acl.isGranted([ROLES.ROLE_VEHICLE_TYPE_GROUP_UPDATE])}
      canRemove={acl.isGranted([ROLES.ROLE_VEHICLE_TYPE_GROUP_DELETE])}
    />
  );
};
